// extracted by mini-css-extract-plugin
export default {"list":"menu-profile_list__bja5W","item":"menu-profile_item__S4Dfd","item_active":"menu-profile_item_active__Qg9iJ","tip":"menu-profile_tip__Wbhiw"};